import { useMemo } from "react";

import { AUDIOBOOK_CATEGORY_TITLE } from "JS/Helpers/Constants";
import { Disclosure } from "JS/Models/Disclosure";
import { Category } from "JS/Models/Audio";
import { useGlobalAudios } from "JS/React/Hooks/Audio";

export const audiobookCategoryId = (categories?: Category[]) =>
    categories?.find(
        (c) =>
            c?.category_title?.trim().toLowerCase() ===
            AUDIOBOOK_CATEGORY_TITLE,
    )?.category_id;

export const useIsAudiobook = (item: object | undefined) => {
    const { categories } = useGlobalAudios();

    const categoryIds =
        item && "category_ids" in item
            ? (item as { category_ids?: string[] }).category_ids
            : undefined;

    return useMemo(() => {
        const id = audiobookCategoryId(categories);
        return !!id && !!categoryIds?.includes(id);
    }, [categories, categoryIds]);
};

export interface AudiobookPartOptions {
    isAudiobook: boolean;
    disclosure?: Disclosure;
    partIndex: number;
    partCount: number;
}

export const audiobookPartDisclosure = (options: AudiobookPartOptions) => {
    const { isAudiobook, disclosure, partIndex, partCount } = options;

    if (!isAudiobook || !disclosure) return disclosure;

    return {
        start: partIndex === 0 ? disclosure.start : undefined,
        end: partIndex === partCount - 1 ? disclosure.end : undefined,
    };
};
